import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaFutbol, FaBolt, FaCoins, FaArrowRight, FaTimes, FaFire, FaTrophy, FaUsers } from 'react-icons/fa';

const SLIDES = [
  {
    icon: FaFutbol,
    color: '##003DA5',
    title: 'Bienvenue dans OM QUIZ !',
    text: 'Teste tes connaissances football et grimpe dans le classement mondial. Réponds vite, gagne plus de points !',
  },
  {
    icon: FaBolt,
    color: '#FFB81C',
    title: 'Plusieurs modes de jeu',
    text: 'JOUER en solo, CHRONOMÉTRÉ avec mode survie, DUEL face à un adversaire, TOURNOI ou CHAMPIONNAT avec de l\'argent à la clé !',
  },
  {
    icon: FaFire,
    color: '#f97316',
    title: 'Streak quotidien',
    text: 'Connecte-toi chaque jour pour maintenir ta flamme et gagner des pièces bonus. Plus tu enchaînes, plus tu gagnes !',
  },
  {
    icon: FaUsers,
    color: '#3b82f6',
    title: 'Invite tes amis',
    text: 'Ajoute des amis depuis ton profil ou le classement. Défiez-vous en duel et suivez vos scores respectifs.',
  },
  {
    icon: FaCoins,
    color: '#8b5cf6',
    title: 'Gagne des récompenses',
    text: 'Chaque bonne réponse te rapporte des coins. Dépense-les à la Boutique pour des bonus XP, des vies et des indices.',
  },
];

const STORAGE_KEY = 'qfl_onboarding_done';

export function shouldShowOnboarding() {
  return !localStorage.getItem(STORAGE_KEY);
}

function Onboarding({ onDone }) {
  const [step, setStep] = useState(0);

  const finish = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    onDone();
  };

  const next = () => {
    if (step < SLIDES.length - 1) setStep(step + 1);
    else finish();
  };

  const slide = SLIDES[step];
  const Icon  = slide.icon;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24,
      }}
    >
      <motion.div
        key={step}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.35 }}
        style={{
          background: 'linear-gradient(135deg, #001a4d, #003DA5)',
          border: '1px solid rgba(255,184,28,0.3)',
          borderRadius: 24,
          padding: '40px 32px 32px',
          maxWidth: 360,
          width: '100%',
          textAlign: 'center',
          position: 'relative',
        }}
      >
        <button
          onClick={finish}
          style={{
            position: 'absolute', top: 14, right: 14,
            background: 'rgba(255,255,255,0.1)',
            border: 'none', borderRadius: '50%',
            width: 28, height: 28, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <FaTimes size={12} color="rgba(255,255,255,0.5)" />
        </button>

        <div
          style={{
            width: 72, height: 72, borderRadius: '50%', margin: '0 auto 20px',
            background: `${slide.color}20`,
            border: `2px solid ${slide.color}40`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <Icon size={30} color={slide.color} />
        </div>

        <h2
          style={{
            color: '#FFB81C', fontFamily: "'Rajdhani', sans-serif",
            fontSize: '1.4rem', fontWeight: 800,
            textTransform: 'uppercase', letterSpacing: '0.05em',
            marginBottom: 12,
          }}
        >
          {slide.title}
        </h2>

        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.92rem', lineHeight: 1.6, marginBottom: 28 }}>
          {slide.text}
        </p>

        {/* Points indicateurs */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginBottom: 24 }}>
          {SLIDES.map((_, i) => (
            <div
              key={i}
              style={{
                width: i === step ? 20 : 8,
                height: 8,
                borderRadius: 4,
                background: i === step ? '#FFB81C' : 'rgba(255,255,255,0.2)',
                transition: 'all 0.3s',
              }}
            />
          ))}
        </div>

        <button
          onClick={next}
          style={{
            width: '100%',
            padding: '14px 0',
            borderRadius: 12,
            background: 'linear-gradient(135deg, #FFB81C, #d97706)',
            border: 'none',
            color: '#001a4d',
            fontWeight: 800,
            fontSize: '1rem',
            fontFamily: "'Rajdhani', sans-serif",
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
          }}
        >
          {step < SLIDES.length - 1 ? 'Suivant' : 'Commencer !'}
          <FaArrowRight size={14} />
        </button>
      </motion.div>
    </div>
  );
}

export default Onboarding;

